
import { TipoConteudo } from 'src/app/model/arquivo.model';
import { Component, OnInit, Injector } from '@angular/core';
import { AtualizacaoInfoRiscoService } from './atualizacao-info-risco.service';
import { JanelaAtualizacaoInformacoesRisco } from 'src/app/model/atualizacao-info-risco.model';
import { ProtocoloArquivoService } from '../../../shared/services/protocolo-arquivo.service';
import { BnUsuarioService } from '@bndes/bndes-ux4/bn-usuario';



@Component({
    selector: 'app-atualizacao-info-risco-envio',
    templateUrl: './atualizacao-info-risco-envio.component.html',
    standalone: false
})
export class AtualizacaoInfoRiscoEnvioComponent implements OnInit {

  titulo = 'Envio de atualização de informações de risco';
  instrucoesEnvio = 'Envie um arquivo com atualização de informações de risco das operações.';
  tipoConteudoArquivo = TipoConteudo.ATUALIZACAO_INFO_RISCO;

  private permitirForaJanela; //não apagar, sendo usada no componente @Input
  private cnpjUsuario?:string;

  public janelaAtual: JanelaAtualizacaoInformacoesRisco;

  constructor(protected injector: Injector,
    private atualizacaoInfoRiscoService: AtualizacaoInfoRiscoService,
    private protocoloArquivoService: ProtocoloArquivoService,
  private bnUsuarioService: BnUsuarioService) {
  }

  ngOnInit() {

     this.bnUsuarioService.usuario$.subscribe(usuario => {
      this.cnpjUsuario = usuario?.cnpj;
      
    });

    this.atualizacaoInfoRiscoService.getJanelaAtual().subscribe((resp) => {
      this.janelaAtual = resp;
    });

    this.permitirEnvio();
  }

  permitirEnvio(){

      this.protocoloArquivoService.getJanelaPermitirEnvio({ cnpjAgente:this.cnpjUsuario, tiposProtocolos:"6&7"})
                .subscribe(permitir => {
                  this.permitirForaJanela = permitir;
                });
    }
      
}
